export default [
	{
		name: 'spacePlane',
		x: -112.5,
		y: 11.2,
		z: -32.5,
		rotation: 8.5,
	},
	{
		name: 'stpPlane',
		x: 0,
		y: 11.2,
		z: 0,
		rotation: 9.4,
	},
	{
		name: 'rmjPlane',
		x: 117.6,
		y: 11.2,
		z: 31.5,
		rotation: -1.7,
	},
	{
		name: 'eldiaPlane',
		x: 37.5,
		y: 11.2,
		z: 113.8,
		rotation: 9.7,
	},
]
